function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Social-icons",
  transform: "translate(-2.000000, -3.000000)",
  fill: "#ffffff",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "2020-Courageous-Sail-Icon-Logo-KO-White",
  transform: "translate(2.000000, 3.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5,2.1999942e-07 C5.59644053,2.1999942e-07 0,5.59644097 0,12.5000002 C0,19.4035595 5.59644053,25.0000002 12.5,25.0000002 C19.403559,25.0000002 25,19.4035595 25,12.5000002 C25.0006214,9.18460356 23.6838606,6.00481838 21.3395211,3.66047888 C18.9951816,1.31613938 15.8153964,-0.000621410497 12.5,2.1999942e-07 Z M12.2656101,14.609507 L4.85889735,14.609507 L15.3783046,7.30358179 L12.2656101,14.609507 Z M13.4586534,15.5470656 L15.7064501,10.2522035 L18.9879052,15.5470656 L13.4586534,15.5470656 Z",
  id: "Shape"
}))));

function SvgCourageous(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "26px",
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Shape") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourageous);
export default __webpack_public_path__ + "static/media/COURAGEOUS.258c56bd.svg";
export { ForwardRef as ReactComponent };